module.exports = __webpack_public_path__ + "images/namsosinternationalef260d179f354e927bfc504af8613940.png";